"use strict";

require("core-js/modules/es.array.flat-map.js");

require("core-js/modules/es.array.unscopables.flat-map.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});

function match(regex, content) {
  var res = regex.exec(content);

  if (!res) {
    return null;
  }

  var fullmatch = res[0],
      capture = res.slice(1);
  return {
    fullmatch: fullmatch,
    capture: capture,
    index: res.index,
    input: res.input
  };
}

exports.match = match;

function minBy(fn) {
  return function (acc, value) {
    if (acc === null) {
      return value;
    }

    var accFn = fn(acc);
    var valueFn = fn(value);
    return accFn <= valueFn ? acc : value;
  };
}

exports.minBy = minBy;

function getText(node) {
  if (typeof node === 'string') {
    return node;
  } else if (Array.isArray(node)) {
    return node.map(getText).join('');
  } else {
    return node.content.map(getText).join('');
  }
}

exports.getText = getText;

function flatMap(list, fn) {
  var _a;

  return (_a = Array.prototype).concat.apply(_a, list.map(fn));
}

exports.flatMap = flatMap;